import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { AdminSpacesEdit } from '@components/templates/admin/spaces';

export const EditSpace = () => {
    const { t } = useTranslation();

    const translations = {
        title: t('admin.spaces-management-edit.metatags.title'),
        description: t('admin.spaces-management-edit.metatags.description'),
    };

    useSEOMetatags({
        ...translations,
        url: SITE_URLS.editSpace,
        index: false,
    });

    return <AdminSpacesEdit />;
};
